// Vendors
import React, { createContext, useContext, useState } from 'react';
// Enumerations
import { AppInformationNeedEnumeration } from 'enumerations/app-information-need.enumeration';
// Types
import { AppInformationContextType } from './types/app-information.context.type';

const AppInformationContext = createContext<AppInformationContextType>(
  {} as AppInformationContextType
);

const AppInformationContextProvider = ({
  children,
}: React.PropsWithChildren): React.ReactElement => {
  const [informationFlags, setInformationFlags] = useState<AppInformationNeedEnumeration[]>([]);

  return (
    <AppInformationContext.Provider value={{ informationFlags, setInformationFlags }}>
      {children}
    </AppInformationContext.Provider>
  );
};

const useAppInformationContextConsumerHook = (): AppInformationContextType =>
  useContext(AppInformationContext);

export { useAppInformationContextConsumerHook, AppInformationContextProvider };
